import React, { useMemo } from 'react';
import { SelectProps as MuiSelectProps, Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import { useUserContext } from '@travelity/web/src/contexts/user';
import { useCurrencyOptions } from '@travelity/web/src/hooks';
import { SearchSelect } from '../search-select';

export type SelectCurrencyProps = MuiSelectProps & {
    width?: string;
    size?: 'small' | 'medium';
    name: string;
    label?: string;
    placeholder?: string;
    required?: boolean;
    showErrors?: boolean;
    availableCurrencies?: boolean;
    formControlSx?: SystemStyleObject<Theme>;
};

const SelectCurrency: React.FC<SelectCurrencyProps> = props => {
    const { availableCurrencies, disabled, ...other } = props;
    const { user } = useUserContext();
    const defaultValue = user ? user.currency : undefined;
    const disableCurrencySelection = user?.subscription
        ? !user.subscription.user?.financial?.multi_currency
        : false;
    const allOptions = useCurrencyOptions();

    const filteredOptions = useMemo(() => {
        return availableCurrencies
            ? allOptions.filter(o => {
                  return (
                      user?.currencies?.find(c => c.name === o.value) ||
                      o.value === user?.currency
                  );
              })
            : allOptions;
    }, [allOptions, availableCurrencies, user?.currencies, user?.currency]);

    return (
        <SearchSelect
            {...other}
            options={filteredOptions}
            disabled={disableCurrencySelection || disabled}
            defaultValue={defaultValue}
        />
    );
};

export default SelectCurrency;
